// import legacyColors from '../legacy/colors';
var colors = {
    purple30: '#C59DFB'
};
export default colors;
